import './index.css'
import dayjs from '@disco/utils/dayjs'
import * as React from 'react'
type Props = {
  time: number
  max?: number
}

/**
 * A component that displays formatted time duration in MM:SS or HH:MM:SS format
 * @param time - Time duration in seconds to display
 * @param max - Maximum time value used to determine format (hours vs minutes/seconds)
 * @returns Div element containing the formatted time string or placeholder for invalid/zero time
 */
const PlayTime = (props: Props): React.ReactElement<'div'> => {
  // @ts-ignore
  const momentTime = dayjs.utc(
    // @ts-ignore
    dayjs.duration(props.time, 'seconds').asMilliseconds(),
  )
  // TODO: replace with dayjs.duration(..)
  const timeMax = props.max || props.time
  const zeroTimeSymbol = '−−:−−'
  let formattedTime

  if (!props.time) {
    formattedTime = zeroTimeSymbol
  } else if (timeMax >= 3600) {
    // TODO: replace with momentTime.hours() >= 1
    formattedTime = momentTime.format('HH:mm:ss')
  } else {
    formattedTime = momentTime.format('mm:ss')
  }

  // TODO: Find out the reason for the invalid date
  if (formattedTime?.includes('Invalid')) {
    formattedTime = zeroTimeSymbol
  }

  return <div className="PlayTime_Cont">{formattedTime}</div>
}

export default PlayTime
